<div class="modal-header">
  <h4 class="modal-title">{{ 'chat.invite.title' | translate }}</h4>
  <button type="button" class="btn-close" [attr.aria-label]="'chat.dialog.cancel' | translate" (click)="close()"></button>
</div>

<div class="modal-body">
  <p class="text-muted mb-2">{{ 'chat.invite.subtitle' | translate:{ name: data.channelName } }}</p>

  <div class="mb-2">
    <input
      type="text"
      class="form-control"
      name="chatInviteFilter"
      [placeholder]="'chat.invite.searchPlaceholder' | translate"
      [attr.aria-label]="'chat.invite.searchPlaceholder' | translate"
      [(ngModel)]="filterTerm"
      (input)="applyFilter()"
    >
  </div>

  @if (loadingDirectory) {
    <div class="d-flex align-items-center gap-2 text-muted pb-2">
      <span class="spinner-border spinner-border-sm" role="status"></span>
      <small>{{ 'chat.dialog.searchingDirectory' | translate }}</small>
    </div>
  }

  @if (filteredPeople.length === 0) {
    <chat-empty-state
      icon="ri-user-search-line"
      titleKey="chat.invite.empty"
      [hintKey]="null"
      [compact]="true"
    ></chat-empty-state>
  } @else {
    <div class="list-group list-group-flush chat-invite-list overflow-auto">
      @for (person of filteredPeople; track trackPerson($index, person)) {
        <button
          type="button"
          class="list-group-item list-group-item-action d-flex align-items-center gap-2 py-2"
          [class.active]="isSelected(person)"
          [disabled]="person.alreadyMember"
          (click)="toggle(person)"
        >
          <!-- Same avatar tile as the bubble popup's list — photo/initials plus
               the presence dot, so who is around is visible before you invite. -->
          <span class="chat-avatar-tile flex-shrink-0">
            @if (person.image) {
              <img [src]="person.image" [alt]="person.name">
            } @else {
              {{ person.initial }}
            }
            <span
              class="chat-avatar-tile__presence rounded-circle"
              [ngClass]="dotFor(person)"
              aria-hidden="true"
            ></span>
          </span>
          <span class="flex-grow-1 chat-name text-start">{{ person.name }}</span>
          @if (person.alreadyMember) {
            <small class="text-muted flex-shrink-0">{{ 'chat.invite.alreadyMember' | translate }}</small>
          } @else if (isSelected(person)) {
            <i class="ri-checkbox-circle-fill text-primary flex-shrink-0"></i>
          } @else {
            <i class="ri-checkbox-blank-circle-line text-muted flex-shrink-0"></i>
          }
        </button>
      }
    </div>
  }
</div>

<div class="modal-footer justify-content-between">
  <small class="text-muted">
    @if (selectedCount > 0) {
      {{ 'chat.dialog.selectedCount' | translate:{ count: selectedCount } }}
    }
  </small>
  <div class="d-flex gap-1">
    <button type="button" class="btn btn-light" (click)="close()">{{ 'chat.dialog.cancel' | translate }}</button>
    <button type="button" class="btn btn-primary" [disabled]="selectedCount === 0 || submitting" (click)="confirm()">
      @if (submitting) {
        <span class="spinner-border spinner-border-sm me-1" role="status"></span>
        <span>{{ 'chat.invite.inviting' | translate }}</span>
      } @else {
        <span>{{ 'chat.invite.confirm' | translate }}</span>
      }
    </button>
  </div>
</div>
